module.exports = __webpack_public_path__ + "img/envelope-act.a0ec7042.svg";